import type { PaymentMethod, Pricing } from '@/types/checkout';
import { convertToDecimalAmount } from './pricing';
import type { BraintreeTokenizePayload } from '@paypal/react-paypal-js/dist/types/types/braintree/commonsTypes';

export const buildPaypalPaymentParams = (pricing: Pricing) => {
  const priceBreakdown = pricing.priceBreakdown;
  const amount = convertToDecimalAmount(priceBreakdown?.priceTotal, pricing.multiplier);
  const unitAmount = convertToDecimalAmount(priceBreakdown?.priceNet, pricing.multiplier);
  const unitTaxAmount = convertToDecimalAmount(priceBreakdown?.tax, pricing.multiplier);
  return {
    flow: 'checkout' as const,
    amount,
    currency: pricing.currencyCode,
    requestBillingAgreement: false,
    intent: 'capture' as const,
    enableShippingAddress: true,
    shippingAddressEditable: false,
    billingAgreementDescription: 'Description of the billng agreement to display to the customer',
    lineItems: [
      {
        quantity: '1',
        unitAmount,
        kind: 'debit' as const,
        unitTaxAmount,
        url: undefined,
        description: '',
        name: 'Payment',
        productCode: 'Payment',
      },
    ],
  };
};

export const buildPaypalPaymentRequest = (
  tokenizationData: BraintreeTokenizePayload,
  paymentMethodSettings: PaymentMethod
) => {
  return {
    paymentProvider: paymentMethodSettings.provider,
    receipt_email: tokenizationData.details.email,
    paymentMethodDisplayName: 'Paypal',
    paymentMethodId: paymentMethodSettings.id,
    params: {
      paymentNonce: tokenizationData.nonce,
      paymentMethodDetails: {
        email: tokenizationData.details.email,
        firstName: tokenizationData.details.firstName,
        lastName: tokenizationData.details.lastName,
        payerId: tokenizationData.details.payerId,
        countryCode: tokenizationData.details.countryCode,
        billingAddress: {
          countryCode: tokenizationData.details.billingAddress?.countryCode ?? tokenizationData.details.countryCode,
        },
        shippingAddress: {
          line1: tokenizationData.details.shippingAddress?.line1 ?? '',
          city: tokenizationData.details.shippingAddress?.city ?? '',
          countryCode: tokenizationData.details.shippingAddress?.countryCode ?? tokenizationData.details.countryCode,
          postalCode: tokenizationData.details.shippingAddress?.postalCode ?? '',
          state: tokenizationData.details.shippingAddress?.state ?? '',
          recipientName:
            tokenizationData.details.shippingAddress?.recipientName ??
            `${tokenizationData.details.firstName} ${tokenizationData.details.lastName}`,
        },
      },
      fraudDetection: {
        forterTokenCookie: '',
      },
    },
  };
};
